export default "__VITE_ASSET__BM$1H5ww__"